/**
 * GA4 (gtag.js) event helpers.
 *
 * Usage:
 *   import { trackEvent } from '../utils/tracking';
 *   trackEvent('free_trial_click', { location: 'hero' });
 *
 * The GA4 tag (G-0HCBW5YKK3) is loaded in public/index.html via gtag.js.
 * Events are sent directly to GA4 using the gtag() function.
 */

export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

/* ── Pre-built event helpers ── */

/** Free-trial / register click — highest priority conversion */
export const trackFreeTrial = (location) =>
  trackEvent('free_trial_click', { location });

/** Demo / contact-sales request */
export const trackDemoRequest = (location) =>
  trackEvent('demo_request', { location });

/** Pricing page view */
export const trackPricingView = () =>
  trackEvent('pricing_view');

/** Contact form submitted */
export const trackContactSubmit = () =>
  trackEvent('contact_form_submit');

/** Chrome extension install click */
export const trackExtensionInstall = (location) =>
  trackEvent('extension_install_click', { location });
